/**
 * AttestationsIndexPage — admin landing for the Attestations area.
 *
 * The legacy AttestationsPage requires a `:id` and lives at
 * `/gi/:id/attestations`. This page is the top-level `/attestations`
 * entry point: it explains the area and links the admin to their Vault
 * to pick a GI.
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';

export function AttestationsIndexPage() {
  const { t } = useTranslation(['attestations', 'dashboard']);
  return (
    <div className="mx-auto max-w-3xl">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('nav.attestations', { ns: 'dashboard' })}
        </h1>
        <p className="mt-1 text-sm text-ink-muted">
          {t('index.body', {
            ns: 'attestations',
            defaultValue: 'Pick a GI from your Vault to inspect its attestation chain.',
          })}
        </p>
      </header>
      <div className="rounded-xl border border-border bg-surface p-6 shadow-subtle">
        <p className="text-sm text-ink-muted">
          {t('index.help', {
            ns: 'attestations',
            defaultValue:
              'Each GI carries one or more signed attestations — engine signatures, RFC 3161 timestamps, ZK commitments. Open a GI from your Vault and choose "Attestations" to see them.',
          })}
        </p>
        <div className="mt-4">
          <Link to="/vault" className="contents">
            <Button>
              {t('index.go_vault', { ns: 'attestations', defaultValue: 'Go to My Vault' })}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
